export const SHIPPING_PRICE = 35

export const getEffectivePrice = (item) => {
  const candidate = item?.final_price ?? item?.discount?.price ?? item?.price ?? 0
  const numericValue = Number(candidate)
  return Number.isFinite(numericValue) ? numericValue : 0
}

const normalizeLabel = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[\s_-]/g, '')
  .toUpperCase()

export const hasBestprice = (item) => {
  if (item?.bestprice === true || item?.has_bestprice === true) {
    return true
  }

  return normalizeLabel(item?.discount?.name) === 'BESTPRICE'
}

export const getCollectionBadge = (item) => {
  if (item?.clearence) {
    return 'Outlet'
  }
  if (item?.package) {
    return 'Pachete'
  }
  if (hasBestprice(item)) {
    return 'BestPrice'
  }
  return null
}

export const getStockLabel = (item) => {
  const stock = Number(item?.stock ?? 0)
  return stock > 0 ? 'În stoc' : 'Stoc furnizor'
}

export const getDisplayBrandName = (item) => {
  const brandName = String(item?.brand?.name || '').trim()
  if (!brandName || normalizeLabel(brandName) === 'BRAND') {
    return ''
  }
  return brandName
}

const toNonNegativeInteger = (value) => {
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return 0
  }
  return Math.floor(numericValue)
}

export const getAvailabilityBreakdown = (item, selectedQuantity) => {
  const quantity = toNonNegativeInteger(selectedQuantity ?? item?.count ?? item?.quantity)
  const stock = toNonNegativeInteger(item?.stock)
  const inStockQuantity = stock > 0 ? Math.min(quantity, stock) : 0
  const onOrderQuantity = Math.max(0, quantity - inStockQuantity)

  return {
    quantity,
    stock,
    inStockQuantity,
    onOrderQuantity,
    hasOnOrderQuantity: onOrderQuantity > 0,
    fullyInStock: quantity > 0 && onOrderQuantity === 0
  }
}

export const getAvailabilityText = (item, selectedQuantity) => {
  const { inStockQuantity, onOrderQuantity } = getAvailabilityBreakdown(item, selectedQuantity)
  const parts = []
  if (inStockQuantity > 0) {
    parts.push(`${inStockQuantity} in stoc`)
  }
  if (onOrderQuantity > 0) {
    parts.push(`${onOrderQuantity} la comanda`)
  }
  return parts.join(', ') || getStockLabel(item)
}

export const hasOnOrderQuantity = (item, selectedQuantity) => (
  getAvailabilityBreakdown(item, selectedQuantity).hasOnOrderQuantity
)

export const canIncreaseCartQuantity = (item, count) => {
  return true
}
